module.exports = __webpack_public_path__ + "static/media/Lock.6c8ab64e.svg";